module.exports = "<h1>Not Found</h1>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/messaging/messaging.html
// module id = 473
// module chunks = 0